// extracted by mini-css-extract-plugin
export default {"mainContainer":"Owner_mainContainer__yyCFW","container":"Owner_container__Pp0Pa","content":"Owner_content__vicik","qr":"Owner_qr__QeQ-l"};